import { useState, useMemo, useEffect } from 'react';

const useSortableTable = (items, config = null, customSortValue = null, resetKey = null) => {
  const [sortConfig, setSortConfig] = useState(config);

  useEffect(() => {
    setSortConfig(config);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey]);

  const sortedItems = useMemo(() => {
    let sortableItems = [...items];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        let aValue = customSortValue ? customSortValue(a, sortConfig.key) : a[sortConfig.key];
        let bValue = customSortValue ? customSortValue(b, sortConfig.key) : b[sortConfig.key];

        const aNull = aValue === null || aValue === undefined || aValue === '';
        const bNull = bValue === null || bValue === undefined || bValue === '';
        if (aNull && bNull) {
          // secondary sort: id descending
          return (b.id || 0) - (a.id || 0);
        }
        if (aNull) return 1;  // nulls always last
        if (bNull) return -1;

        if (typeof aValue === 'string') aValue = aValue.trim().toLowerCase();
        if (typeof bValue === 'string') bValue = bValue.trim().toLowerCase();

        if (aValue < bValue) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        // secondary sort: id descending
        return (b.id || 0) - (a.id || 0);
      });
    }
    return sortableItems;
  }, [items, sortConfig, customSortValue]);

  const requestSort = (key) => {
    let direction = 'ascending';
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'ascending'
    ) {
      direction = 'descending';
    }
    
    setSortConfig({ key, direction });
  };

  const getSortIndicator = (key) => {
    if (!sortConfig || sortConfig.key !== key) {
        return <i className="sort-icon fa fa-sort" style={{ marginLeft: '5px' }}></i>;
    }
    return sortConfig.direction === 'ascending'
      ? <span className="sort-icon" style={{ marginLeft: '5px' }}>▲</span>
      : <span className="sort-icon" style={{ marginLeft: '5px' }}>▼</span>;
  };

  return { items: sortedItems, requestSort, sortConfig, getSortIndicator };
};

export default useSortableTable;